module.exports = __webpack_public_path__ + "static/media/bar-chart.26853d7d.svg";